<ng-template #recursiveList let-nodes let-level="level">
  <ul class="treeview" *ngIf="nodes.length">
    <li *ngFor="let node of nodes" [style.padding-left.px]="getLevel(node) * 5">
      <div *ngIf="node.NAME && node.ID && node.SHOW">
        <div [class.active]="originalNode.NAME === node.NAME" class="node-line">
          <span
            class="icon-active-color"
            *ngIf="node.concept.childCt > 0 && !node.concept.childrenLoaded && node.selectedTreeNode"
            (click)="clickPlus(node)"
            [ngClass]="{ 'default-pointer': !node.loading }"
            ><i class="fas fa-plus"></i
          ></span>

          <span
            class="icon-active-color default-pointer"
            *ngIf="
              node.concept.childCt > 0 &&
              !node.concept.expanded &&
              !node.concept.childrenLoaded &&
              node.concept.children?.length !== 1 &&
              !node.selectedTreeNode
            "
            (click)="expandNode(node)"
            ><i class="fas fa-chevron-right"></i
          ></span>

          <span
            class="icon-active-color default-pointer"
            *ngIf="node.concept.childCt > 0 && node.concept.childrenLoaded && !node.concept.expanded"
            (click)="expandNode(node)"
            ><i class="fas fa-chevron-right"></i
          ></span>

          <span class="icon-active-color default-pointer" *ngIf="node.concept.childCt > 0 && node.concept.expanded" (click)="collapseNode(node)"
            ><i class="fas fa-chevron-down"></i
          ></span>

          <span title="Leaf Node" class="icon-active-color" *ngIf="node.concept.childCt === 0"><i class="fas fa-leaf"></i></span>

          <span [ngClass]="{ 'hierarchy-active': node.ID === selectedConcept.code }" class="line-limit" title="{{ node.ID + ' ' + node.NAME }}">
            <span *ngIf="node.ID !== 'root'" class="pr-1"
              ><a
                (click)="onMouseClick($event, false)"
                (contextmenu)="onMouseClick($event, true)"
                class="hierarchy-tree-concept-id default-pointer"
                (click)="click(node?.concept?.concept)"
                [routerLink]="node?.link"
                [queryParams]="getConceptQueryParams(node?.concept?.concept)"
                >{{ node.ID }}</a
              ></span
            >
            <span *ngIf="node.ID === 'root' && node.concept.childCt < 100" class="pr-1"
              ><span class="hierarchy-tree-concept-id">{{ node.ID }}</span></span
            >
            {{ node.NAME }}</span
          >
        </div>
      </div>
      <div *ngIf="node.loading" class="pb-2"><app-progress [short]="true"></app-progress></div>
      <!-- Nested List for Children -->
      <ng-container *ngIf="node.SHOW">
        <ng-container *ngFor="let child of node.concept.children; let j = index">
          <ng-container>
            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: child, level: level + 1 }"></ng-container>
          </ng-container>
        </ng-container>
        <div
          *ngIf="
            node.concept.expanded &&
            !getShowAllForNode(node) &&
            getTotalChildrenForNode(node) >= node.concept.children?.length &&
            getTotalChildrenForNode(node) - node.concept.children?.length > 0
          "
          class="show-all"
        >
          <span (click)="showMore(node)" class="hierarchy-tree-concept-id default-pointer" title="Load 10 more"
            >... {{ getTotalChildrenForNode(node) - node.concept.children?.length }} more</span
          >
          <span *ngIf="getTotalChildrenForNode(node) - node.concept.children?.length <= 1000" (click)="showAll(node)">
            [<span class="hierarchy-tree-concept-id default-pointer">show all</span>]</span
          >
        </div>
      </ng-container>
    </li>
  </ul>
</ng-template>
<ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: nodes, level: 0 }"></ng-container>
<div *ngIf="loadMoreAll" class="pb-2">
  <app-progress [short]="true"></app-progress>
</div>
